import React from 'react'

import img1 from '../assets/images/target035.png';
import img2 from '../assets/images/target036.png';
import img3 from '../assets/images/target037.webp';
import img4 from '../assets/images/target038.webp';

export default function Section18() {
    return (
        <div className="section">
            <h2>Appendix B: Importing Unicode CSV Files to Excel</h2>
            <p>Microsoft Excel will attempt to import the CSV files created by GradeBook Pro but if the file is encoded with Unicode (indicated by –UC appended to the file name) the import required the following procedure.</p>

                <div className="box-container">
                    <div className="heading">Importing CSV Files to Microsoft Excel</div>
                    <div className="body">
                        <div>
                            <p>1. You need the .csv files on your computer so that they can be imported into Excel (see Appendix A).</p>
                            <p>2. Open Excel (do not double-click the CSV file, open Excel manually).</p>
                            <p>3. Click “File” -{'>'} “Import”. You should see the following window (or something similar depending on which version of Excel you are using):</p>
                            <img src={img1} alt="importing csv files to ms excel" />
                            <p>4. Select “CSV File” and click “Import”. You will be presented with the following:</p>
                            <img src={img2} alt="csv file import" />
                            <p>5. Select “Delimited” and click “Next”. This will appear:</p>
                            <img src={img3} alt="delimited" />
                            <p>6. Make sure that “Comma” is selected and that “Treat consecutive...” is deselected (as above).</p>
                            <p>7. Click “Finish” and “OK”.</p>
                            <img src={img4} alt="" />
                            <p>8. The data should now be formatted properly. You can save the data as an Excel file to preserve the proper formatting.</p>
                        </div>
                    </div>
                </div>
        </div>
    )
}
